export const benefitsAndCreditsQuestions: Record<string, any> = {
  childBenefits: {
    labelKey: 'applicationForm.BENEFITS_AND_CREDITS.hasChildBenefits.label',
    booleanQuestionFormKey: 'hasChildBenefits',
    adornmentKey: 'common.fourWeeks',
    explanationKey: 'applicationForm.BENEFITS_AND_CREDITS.hasChildBenefits.explanation',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
  disabilityAllowance: {
    labelKey: 'applicationForm.BENEFITS_AND_CREDITS.hasDisabilityAllowance.label',
    booleanQuestionFormKey: 'hasDisabilityAllowance',
    adornmentKey: 'common.fourWeeks',
    explanationKey: 'applicationForm.BENEFITS_AND_CREDITS.hasDisabilityAllowance.explanation',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
  taxCredits: {
    labelKey: 'applicationForm.BENEFITS_AND_CREDITS.hasTaxCredits.label',
    booleanQuestionFormKey: 'hasTaxCredits',
    adornmentKey: 'common.monthly',
    explanationKey: 'applicationForm.BENEFITS_AND_CREDITS.hasTaxCredits.explanation',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
};
